module.exports = __webpack_public_path__ + "img/Fernando Collado.88bedcac.jpg";